import { defineStore } from "pinia";

import { Entity } from "@/enums/entityProfiles";
import profilesApiService from "@/services/modules/profiles";

import type { IndividualProfileState } from "@/models/IndividualProfile";

const getDefaultState = (): IndividualProfileState => ({
  currentIndividualProfile: undefined,
  meta: undefined,
});

export const useIndividualProfileStore = defineStore("individualProfile", {
  state: getDefaultState,
  actions: {
    async loadCurrentIndividualProfile(profileId: string) {
      const data = await profilesApiService.getSingleProfileByType(
        Entity.individual,
        profileId
      );
      this.currentIndividualProfile = data;
      return data;
    },
    async updateIndividualProfile(payload: {
      profileId: string;
      params: Record<string, unknown>;
    }) {
      const data = await profilesApiService.updateProfileByType(
        Entity.individual,
        payload.profileId,
        payload.params
      );
      this.currentIndividualProfile = data;
      return data;
    },
    async updateClientTrackingToken(payload: {
      profileId: string;
      client_token: string;
    }) {
      return await this.updateIndividualProfile({
        profileId: payload.profileId,
        params: { client_tracking_token: payload.client_token },
      });
    },
  },
});
